import axios from "axios";

const API_ENDPOINT = `${process.env.REACT_APP_API_ENDPOINT}`;

const callAPI = async (path, params) => {
  return (
    await axios.get(API_ENDPOINT + path, {
      params,
    })
  ).data;
};

class FootballAPI {
  async getFixturesAndRounds(competitionId, round) {
    const result = await callAPI("/fixtures-rounds", {
      competitionId,
      round,
    });

    return result;
  }

  async getFixture(id) {
    return await callAPI("/fixtures", { id });
  }

  async getStandings(competitionId, season) {
    const params = {
      competitionId,
      season,
    };

    return callAPI("/standings", params);
  }

  async getFixtures(competitionId, season, round) {
    const params = {
      competitionId,
      season,
      round,
    };

    return callAPI("/fixtures", params);
  }

  async getFixturesByDate(date) {
    const params = {
      date,
    };

    return callAPI("/fixtures", params);
  }

  async getCompetitionRounds(competitionId, season) {
    const params = {
      competitionId,
      season,
    };

    return callAPI("/rounds", params);
  }
}

const footballAPI = new FootballAPI();

export default footballAPI;
